import axios from "axios"
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { ResponseRequest, ResponseRequestGeneric } from "components/Types/GeneralTypes";
import configData from "config.json";
import { authHeaderWithToken, authHeaderWithUserData } from "helpers/auth-header";
import { authenticationService } from "services/authentication.service";
import { InformacionGeneralNotificacion } from "./TypesNotificacionEmbarazo";

export async function ObtenerInformacionGeneralNotificacionEmbarazos(handleError: (info?: any) => void) {
    const url = configData.SERVER_URL + "NotificacionEmbarazo/InformacionGeneral";
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var informacionNotificacion: InformacionGeneralNotificacion = {
        anio: -1, 
        historial: [],
        acuerdoMediosElectronicos: true,

    }
    var infoResponse: ResponseRequest = { status: -1, dataResponse: informacionNotificacion }
    try {

        const respuesta = await axios.get(url,
            {
                headers: authHeaderWithUserData(infoUsuario)
            }
        )

        informacionNotificacion = respuesta.data;

        infoResponse = {
            status: respuesta.status,
            dataResponse: informacionNotificacion,
        }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            infoResponse = {
                status: error.response.status,
                dataResponse: informacionNotificacion,
                errorMessage: error.response.data ?? ""
            }
            handleError(infoResponse.errorMessage);
        }
        else {
            handleError();
        }
    }

    return infoResponse;

}

export async function NotificacionEmbarazoCreacion(formData: FormData, setIsSubmitting: React.Dispatch<React.SetStateAction<boolean>>) {
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var respuestaResponse: ResponseRequest = { status: -1 }
    const url = configData.SERVER_URL + "NotificacionEmbarazo/CrearNotificacionEmbarazo"

    // Deshabilitar el botón de envío
    setIsSubmitting(true);

    try {
        const respuesta = await axios.post(url, formData,
            {
                headers: authHeaderWithToken(infoUsuario.token),
            }
        )
        respuestaResponse = { status: respuesta.status, dataResponse: respuesta.data }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status, errorMessage: error.response.data }

        }
    } finally {
        // Rehabilitar el botón después de la solicitud
        setIsSubmitting(false);
    }
    return respuestaResponse
}

export async function AnularNotificacionEmbarazo(idNotificacion: number, fechaInterrupcion: Date) {
    const infoUsuario: UserData = authenticationService.currentUserValue;
    const fechaInterrupcionString = fechaInterrupcion.toISOString();
    const URL = configData.SERVER_URL + `NotificacionEmbarazo/AnularNotificacionEmbarazo/${idNotificacion}/${fechaInterrupcionString}`

    try {
        const respuesta = await axios.put(URL, {}, {
            headers: authHeaderWithToken(infoUsuario.token)
        })

        return 1
    } catch (error) {
        return -1

    }



}

